<template>
  <v-container grid-list-lg class="pa-0" fluid>
    <Create :createDialog="createDialog" @close="createDialog = false" @submit="getList"></Create>
    <Edit :editDialog="editDialog" @close="editDialog = false" @submit="getList" :editDonor="selectedDonor"></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle :access="checkRightStatus(1)" title="Donors" @add="add" />
      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field v-model="search" label="Search" outlined prepend-inner-icon="search" rounded dense single-line
            hide-details clearable></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex shrink>
          <v-checkbox label="Show Balance Only" v-model="ShowBalanceOnly"></v-checkbox>
        </v-flex>
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="donors" :search="search" :loading="loading" :sortDesc="sortDesc"
          @current-items="updateTotal" :sort-by="sortBy" :page.sync="page" :items-per-page="itemsPerPage">
          <template v-slot:item="{ item }">
            <tr class="pointer">
              <td class="text-left">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ item.createdAt | moment("from", "now") }}</span>
                  </template>
                  <span> {{ item.createdAt | moment("L LT") }}</span>
                </v-tooltip>
              </td>
              <td class="text-decoration-underline blue--text text-left" @click="viewProfileNewTab(item)" v-html="$options.filters.highlight(item.name, search.toLowerCase())
                ">
                {{ item.name }}
              </td>
              <td>
                <!-- <v-chip v-if="item.stripeId" small class="ma-2" color="blue dark-3" text-color="white">
                  <span class="font-weight-bold">Stripe</span>
                </v-chip> -->
                <v-tooltip bottom v-if="item.stripeId">
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar size="10" color="blue" v-bind="attrs" v-on="on" />
                  </template>
                  <span>Paying With Stripe</span>
                </v-tooltip>

                <v-tooltip bottom v-if="item.payCompassId">
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar size="10" color="yellow" v-bind="attrs" v-on="on" />
                  </template>
                  <span>Set for online payment</span>
                </v-tooltip>
              </td>
              <td class="text-left" @click="viewProfile(item)" v-html="$options.filters.highlight(
                item.phoneNumber,
                search.toLowerCase()
              )
                ">
                {{ item.phoneNumber }}
              </td>
              <td class="text-left" @click="viewProfile(item)" v-html="$options.filters.highlight(item.email, search.toLowerCase())
                ">
                {{ item.email }}
              </td>

              <!-- <td
                class="text-left"
                @click="viewProfile(item)"
                v-html="
                  $options.filters.highlight(item.address, search.toLowerCase())
                "
              >
                {{ item.address }}
              </td> -->
              <!-- <td
                class="text-left"
                @click="viewProfile(item)"
                v-html="
                  $options.filters.highlight(item.city, search.toLowerCase())
                "
              >
                {{ item.city }}
              </td> -->

              <td class="text-right" @click="viewProfile(item)">
                <span>{{
                  item.balance | currency
                  }}</span>
              </td>

              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="menu-button">
                    <v-list-item @click="viewProfile(item)">
                      <v-list-item-title>Profile</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item v-if="checkRightStatus(3)" @click="editDonor(item)">
                      <v-list-item-title>{{
                        $t("buttons.edit")
                        }}</v-list-item-title>
                    </v-list-item>
                    <DeleteDonor v-if="checkRightStatus(4)" :donor="item" @submit="getList()" />
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <template v-slot:body.append="{ headers }">
            <tr :style="{ 'background-color': $style.listTotal.filter }">
              <td :colspan="headers.length - 2" class="text-right font-weight-bold">
                List Total
              </td>

              <td class="text-right font-weight-bold">
                {{ total | currency }}
              </td>
              <td></td>
            </tr>
            <tr :style="{ 'background-color': $style.listTotal.result }">
              <td :colspan="headers.length - 2" class="text-right font-weight-bold">
                Result Total
              </td>

              <td class="text-right font-weight-bold">
                {{ fullTotal | currency }}
              </td>
              <td></td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import donorService from "../service.js";
import DeleteDonor from "@/modules/Donors/components/DeleteDonor.vue";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
export default {
  data() {
    return {
      ShowBalanceOnly: false,
      createDialog: false,
      editDialog: false,
      selectedDonor: null,
      total: 0,
      fullTotal: 0,
      headers: [
        {
          text: "Created At",
          align: "left",
          value: "createdAt",
          sortable: true,
        },
        {
          text: "Name",
          value: "name",
          sortable: true,
          align: "left",
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
        {
          text: "Phone Number",
          value: "phoneNumber",
          align: "left",
          sortable: true,
        },
        {
          text: "Email Address",
          value: "email",
          align: "left",
          sortable: true,
        },
        // {
        //   text: "Address",
        //   value: "address",
        //   align: "left",
        //   sortable: true,
        // },
        {
          text: this.$t("labels.balance"),
          value: "balance",
          align: "left",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      page: 1,
      sortBy: "createdAt",
      pageCount: 0,
      sortDesc: true,
      itemsPerPage: 10,
      search: "",
      refundDialog: false,
      selectedTask: null,
      donors: [],
      loading: true,
    };
  },
  async created() {
    if (this.$route.query && this.$route.query.ShowBalanceOnly) {
      this.ShowBalanceOnly = this.$route.query.ShowBalanceOnly
    }
    this.getList();
    // this.$events.listen("DonorListEvent", () => this.getList());

    // this.reset();
  },
  // beforeDestroy() {
  //   this.$events.remove("DonorListEvent");
  // },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  watch: {
    ShowBalanceOnly() {
      this.getList()
    },
    search(val) {
      if (!val) {
        this.search = "";
      }
    },
  },
  components: {
    Create,
    Edit,
    DeleteDonor,
  },
  filters: {
    highlight(words, query) {
      if (query) {
        var check = new RegExp(query.toLowerCase(), "ig");
        if (words) {
          return words.toString().replace(check, function (matchedText) {
            return '<span class="highlight">' + matchedText + "</span>";
          });
        } else {
          return words;
        }
      } else {
        return words;
      }
    },
  },
  methods: {
    updateTotal(val) {
      this.total = 0;
      val.map((row) => {
        this.total += row.balance;
      });
    },
    viewProfile(val) {
      //  let routeData = this.$router.resolve({
      //   path: `/parents/${val.id}/profile`,
      // });
      // window.open(routeData.href, "_blank");
      this.$router.push({ path: `/donors/${val.id}/profile` });
    },
    viewProfileNewTab(val) {
      let routeData = this.$router.resolve({
        path: `/donors/${val.id}/profile`,
      });
      window.open(routeData.href, "_blank");
    },
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      let where = {}
      if (this.ShowBalanceOnly) {
        where.hideZero = true
      }
      return donorService
        .getAll(where)
        .then((response) => {
          console.log("response", response);
          this.donors = response.data;
          this.fullTotal = 0;
          this.donors.map((row) => {
            this.fullTotal += row.balance;
          });
          this.loading = false;
          return response;
        })
        .catch((error) => {
          throw error;
        });
    },
    editDonor(donor) {
      this.selectedDonor = donor;
      this.editDialog = true;
    },
    deleteDonor(donor) {
      if (!this.checkRightStatus(39)) {
        this.$swal(
          "Delete donor",
          "You are not allow to delete donor with balance.",
          "warning"
        );
        return false;
      }
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          donorService
            .delete(donor.id)
            .then((response) => {
              if (response.data) {
                this.$swal("Deleted!", "Donor has been deleted.", "success");
                this.getList();
              }
            })
            .catch((error) => {
              throw error;
            });
        }
      });
    },
  },
};
</script>

<style scoped></style>
